{
	"title": "Administrer erklæringer",
	"createDeclaration": "Lag erklæring"
}
